var exports = {
  "iE": "x234b8571--bb8c5d--wrapper",
  "wx": "x234b8571--bb8c5d--header",
  "Qs": "x234b8571--bb8c5d--content",
  "qr": "x234b8571--bb8c5d--footer",
};

module.exports = exports;
